import * as actionTypes from "../actionTypes";

export const uploadCPsList = (data) => {
  return {
    type: actionTypes.UPLOAD_CP_MANAGERS_LIST_START,
    payload: data,
  };
};
export const getCpManagersList = (data) => {
  return {
    type: actionTypes.GET_CP_MANAGERS_LIST_START,
    payload: data,
  };
};
export const getCpManagersListSuccess = (data) => {
  return {
    type: actionTypes.GET_CP_MANAGERS_LIST_SUCCESS,
    payload: data.data,
  };
};
export const getCpManagersListFailure = (data) => {
  return {
    type: actionTypes.GET_CP_MANAGERS_LIST_FAILURE,
    payload: data,
  };
};



export const getCpContractList = (data) => {
  return {
    type: actionTypes.GET_CP_CONTRACT_LIST_START,
    payload: data,
  };
};
export const getCpContractListSuccess = (data) => {
  return {
    type: actionTypes.GET_CP_CONTRACT_LIST_SUCCESS,
    payload: data.data,
  };
};
export const getCpContractListFailure = (data) => {
  return {
    type: actionTypes.GET_CP_CONTRACT_LIST_FAILURE,
    payload: data,
  };
};
export const addContractStart = (data) => {
  return {
    type: actionTypes.ADD_CONTRACT_START,
    payload: data,
  };
};
export const addContractSuccess = (data) => {
  const d={success:data.message}
  return {
    type: actionTypes.ADD_CONTRACT_SUCCESS,
    payload: d,
  };
};
export const addContractFailure = (data) => {
  return {
    type: actionTypes.ADD_CONTRACT_FAILURE,
    payload: data,
  };
};


export const editCp = (data) => {
  return {
    type: actionTypes.EDIT_CP,
    payload: data,
  };
};
export const addNewCpStart = (data) => {
  return {
    type: actionTypes.ADD_NEW_CP_START,
    payload: data,
  };
};
export const addNewCpSuccess = (data) => {
  return {
    type: actionTypes.ADD_NEW_CP_SUCCESS,
    payload: data.data,
  };
};
export const addNewCpFailure = (data) => {
  return {
    type: actionTypes.ADD_NEW_CP_FAILURE,
    payload: data,
  };
};
export const getCpStart = (data) => {
  return {
    type: actionTypes.GET_CP_START,
    payload: data,
  };
};
export const getCpSuccess = (data) => {
  return {
    type: actionTypes.GET_CP_SUCCESS,
    payload: data.data,
  };
};
export const getCpFailure = (data) => {
  return {
    type: actionTypes.GET_CP_FAILURE,
    payload: data,
  };
};


export const  activeCpManager = (data) => {
  return {
    type: actionTypes.ACTIVE_CP_MANAGER,
    payload: data,
  };
};
export const cpMessageHandler = () => {
  return {
    type: actionTypes.CP_MESSAGE_HANDLER,
    payload: null,
  };
};
